import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/premiumButtons.css";
import "@/videoGlow.css";
import "@/liquidGlass.css";
import "@/scrollReveal.css";
import "@/saGeo.css";
import { initPremiumButtons } from "@/lib/premiumButtons";
import { initLiquidGlass } from "@/lib/liquidGlass";
import { initScrollReveal } from "@/lib/scrollReveal";
import App from "@/App";

initPremiumButtons();
initLiquidGlass();
initScrollReveal();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
